import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0d1b2e] text-slate-300">
      {/* ヘッダー */}
      <header className="bg-[#071020] border-b border-slate-800">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer">
            <span className="text-2xl font-bold text-amber-400 tracking-wide">ProjectMaster</span>
          </Link>
          <Link 
            to="/" 
            className="text-sm text-slate-400 hover:text-amber-400 transition-colors flex items-center gap-1 cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            トップページへ戻る
          </Link>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-white mb-8 text-center">プライバシーポリシー</h1>
        
        <div className="bg-[#071020] rounded-lg p-8 space-y-8">
          {/* 前文 */}
          <section>
            <p className="text-sm leading-relaxed">
              AtZBusinessPartners株式会社（以下「当社」といいます）は、当社が提供するサービス「ProjectMaster」（以下「本サービス」といいます）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
            </p>
          </section>

          {/* 第1条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">1</span>
              個人情報の定義
            </h2>
            <p className="text-sm leading-relaxed pl-10">
              個人情報とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
            </p>
          </section>

          {/* 第2条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">2</span>
              個人情報の収集方法
            </h2>
            <p className="text-sm leading-relaxed pl-10 mb-3">
              当社は、ユーザーが利用登録をする際に氏名、生年月日、住所、電話番号、メールアドレス、職務経歴、スキル情報などの個人情報をお尋ねすることがあります。また、ユーザーと提携先などとの間でなされたユーザーの個人情報を含む取引記録や決済に関する情報を、当社の提携先（情報提供元、広告主、広告配信先などを含みます。以下「提携先」といいます）などから収集することがあります。
            </p>
          </section>

          {/* 第3条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">3</span>
              個人情報を収集・利用する目的
            </h2>
            <p className="text-sm leading-relaxed pl-10 mb-3">
              当社が個人情報を収集・利用する目的は、以下のとおりです。
            </p>
            <ul className="text-sm space-y-2 pl-10 list-disc list-inside">
              <li>本サービスの提供・運営のため</li>
              <li>ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）</li>
              <li>案件紹介、マッチングサービスの提供のため</li>
              <li>ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等の案内のメールを送付するため</li>
              <li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
              <li>利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため</li>
              <li>ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため</li>
              <li>サービス改善、新サービス開発のための分析・統計データ作成のため</li>
              <li>上記の利用目的に付随する目的</li>
            </ul>
          </section>

          {/* 第4条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">4</span>
              利用目的の変更
            </h2>
            <p className="text-sm leading-relaxed pl-10">
              当社は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。利用目的の変更を行った場合には、変更後の目的について、当社所定の方法により、ユーザーに通知し、または本ウェブサイト上に公表するものとします。
            </p>
          </section>

          {/* 第5条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">5</span>
              個人情報の第三者提供
            </h2>
            <p className="text-sm leading-relaxed pl-10 mb-3">
              当社は、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
            </p>
            <ul className="text-sm space-y-2 pl-10 list-disc list-inside">
              <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
              <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
              <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
              <li>案件紹介先企業への情報提供について、ユーザーの同意を得た場合</li>
            </ul>
          </section>

          {/* 第6条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">6</span>
              個人情報の開示
            </h2>
            <p className="text-sm leading-relaxed pl-10">
              当社は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
            </p>
            <ul className="text-sm space-y-2 pl-10 list-disc list-inside mt-3">
              <li>本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
              <li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
              <li>その他法令に違反することとなる場合</li>
            </ul>
          </section>

          {/* 第7条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">7</span>
              個人情報の訂正および削除
            </h2>
            <p className="text-sm leading-relaxed pl-10">
              ユーザーは、当社の保有する自己の個人情報が誤った情報である場合には、当社が定める手続きにより、当社に対して個人情報の訂正、追加または削除（以下「訂正等」といいます）を請求することができます。当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
            </p>
          </section>

          {/* 第8条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">8</span>
              個人情報の利用停止等
            </h2>
            <p className="text-sm leading-relaxed pl-10">
              当社は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下「利用停止等」といいます）を求められた場合には、遅滞なく必要な調査を行います。前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。
            </p>
          </section>

          {/* 第9条 */}
          <section>
            <h2 className="text-xl font-semibold text-amber-400 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-amber-400/10 rounded flex items-center justify-center text-sm">9</span>
              プライバシーポリシーの変更
            </h2>
            <p className="text-sm leading-relaxed pl-10">
              本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
            </p>
          </section>

          {/* お問い合わせ窓口 */}
          <section className="border-t border-slate-800 pt-8">
            <h2 className="text-xl font-semibold text-amber-400 mb-4">お問い合わせ窓口</h2>
            <div className="text-sm space-y-2 bg-slate-900/50 p-6 rounded-lg">
              <p className="font-semibold text-white">AtZBusinessPartners株式会社</p>
              <p>〒150-0042 東京都渋谷区宇田川町1-12-1405</p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-amber-400"></i>
                <a href="mailto:projectmaster@atz-bp.co.jp" className="text-amber-400 hover:text-amber-300 transition-colors">
                  projectmaster@atz-bp.co.jp
                </a>
              </p>
            </div>
          </section>

          {/* 制定日 */}
          <div className="text-right text-sm text-slate-500 pt-4">
            <p>制定日：2025年1月1日</p>
          </div>
        </div>
      </main>

      {/* フッター */}
      <footer className="bg-[#071020] border-t border-slate-800 py-6 mt-12">
        <div className="container mx-auto px-4 text-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} AtZBusinessPartners株式会社 All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
}